import MatomoTracker from '@streamr/matomo-tracker';
import { Env } from '../Env';
const PRODUCTION_SITE_ID = 3;
const DEVELOPMENT_SITE_ID = 4;
let matomoInstance;
export function getMatomoTracker() {
    const matomoInDevEnabled = Env.ENABLE_MATOMO_IN_DEV;
    if (!Env.isProduction() && !matomoInDevEnabled) {
        return undefined;
    }
    if (!matomoInstance) {
        matomoInstance = new MatomoTracker({
            urlBase: 'https://matomo.streamr.network/',
            siteId: Env.isProduction()
                ? PRODUCTION_SITE_ID
                : DEVELOPMENT_SITE_ID,
            cookieDomain: '*.streamr.network',
            domains: ['*.streamr.network'],
            enableCrossDomainLinking: true,
        });
    }
    return matomoInstance;
}
export function trackPageView() {
    const matomo = getMatomoTracker();
    if (matomo) {
        matomo.trackPageView({
            href: window.location.origin + window.location.pathname, // redact URL query parameters
        });
    }
}
export function trackEvent(params) {
    const matomo = getMatomoTracker();
    if (matomo) {
        matomo.trackEvent({
            ...params,
            href: window.location.origin + window.location.pathname, // redact URL query parameters
        });
    }
}
